module.exports = __webpack_public_path__ + "static/2i-db53fe94622d2fbbf2fc6a22411cbd7e.woff";